import { Markdown } from "./markdown"
import type { FilePreviewHandler, FilePreviewProps } from "./file-preview-registry"

export function MarkdownPreview(props: FilePreviewProps) {
  return (
    <div
      class="file-preview-markdown"
      style={{
        width: "100%",
        "min-height": `${props.viewportHeight ?? 400}px`,
        padding: "16px 24px",
      }}
    >
      <Markdown text={props.contents} cacheKey={props.cacheKey} />
    </div>
  )
}

export const markdownHandler: FilePreviewHandler = {
  extensions: ["md", "markdown"],
  hasSourceToggle: true,
  render: (props) => <MarkdownPreview {...props} />,
}
